import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  faWhatsapp,
} from '@fortawesome/free-brands-svg-icons'
import {
  faAddressCard,
  faCalendarAlt,
  faCreditCard,
  faMap,
  faPlayCircle,
  faUser,
} from '@fortawesome/free-regular-svg-icons'
import {
  faArrowLeft,
  faArrowRight,
  faAt,
  faBars,
  faCalculator,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faDollarSign,
  faDownload,
  faEdit,
  faEnvelope,
  faMapMarkerAlt,
  faMobileAlt,
  faPhone,
  faPhoneAlt,
  faQuestionCircle,
  faSearch,
  faSearchMinus,
  faSearchPlus,
  faSortDown,
  faSpinner,
  faTimes,
} from '@fortawesome/free-solid-svg-icons'

const ICONS_LIST = {
  fab: { // brand
    'whatsapp': faWhatsapp,
  },
  far: { // regular
    'address-card': faAddressCard,
    'calendar-alt': faCalendarAlt,
    'credit-card': faCreditCard,
    'map': faMap,
    'play-circle': faPlayCircle,
    'user': faUser,
  },
  fas: { // solid
    'arrow-left': faArrowLeft,
    'arrow-right': faArrowRight,
    'at': faAt,
    'bars': faBars,
    'calculator': faCalculator,
    'check': faCheck,
    'chevron-down': faChevronDown,
    'chevron-left': faChevronLeft,
    'chevron-right': faChevronRight,
    'chevron-up': faChevronUp,
    'dollar-sign': faDollarSign,
    'download': faDownload,
    'edit': faEdit,
    'envelope': faEnvelope,
    'map-marker-alt': faMapMarkerAlt,
    'mobile-alt': faMobileAlt,
    'phone': faPhone,
    'phone-alt': faPhoneAlt,
    'question-circle': faQuestionCircle,
    'search': faSearch,
    'search-minus': faSearchMinus,
    'search-plus': faSearchPlus,
    'sort-down': faSortDown,
    'spinner': faSpinner,
    'times': faTimes,
  },
}

const IconComponent = ({ iconType = 'fas', icon, ...rest }) => {
  return ICONS_LIST[iconType][icon] ? (
    <FontAwesomeIcon icon={ICONS_LIST[iconType][icon]} {...rest} />
  ) : ''
}

export default React.memo(IconComponent)



// WEBPACK FOOTER //
// ./src/components/shared/elements/Icon.js